import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Card, Query } from '@deckplan.io/common';

import * as qs from 'qs';
import { Pagination } from '@deckplan.io/common/records';
import { Mockable } from '../mocks/mockable.decorator';

export interface QueryOptions {
    pagination: Partial<Pagination>;
    query: Query;
}

export interface CardsAndTotalCount {
    totalCount: number;
    cards: Card[];
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class CardService {

    private readonly prefix = 'cards';

    constructor(private readonly http: HttpClient) {}

    public getCards(queryOptions: QueryOptions): Observable<CardsAndTotalCount> {
        let url = `${environment.apiUrl}/${environment.apiVersion}/${this.prefix}?pagination=${encodeURIComponent(qs.stringify(queryOptions.pagination))}`;

        if (queryOptions.query) {
            url += '&filter=' + encodeURIComponent(qs.stringify(queryOptions.query));
        }

        return this.http.get(url, {observe: 'response'})
            .pipe(
                map(res => ({totalCount: parseInt(res.headers.get('total-count'), 10), cards: res.body as any[]}))
            );
    }

    public getUniqueCardsByName(constraints: {ids: string[]; names: string[]}, pagination: Pagination): Observable<CardsAndTotalCount> {
        const url = `${environment.apiUrl}/${environment.apiVersion}/${this.prefix}/unique-by-name?pagination=${encodeURIComponent(qs.stringify(pagination))}`;

        return this.http.post(url, constraints, { observe: 'response'})
            .pipe(
                map(res => ({totalCount: parseInt(res.headers.get('total-count'), 10), cards: res.body as any[]}))
            );
    }

    public getCard(id: string): Observable<Card> {
        return this.http.get<Card>(`${environment.apiUrl}/${environment.apiVersion}/${this.prefix}/${id}`);
    }

    public getPopluarCardsByType(type: string, count: number): Observable<Card[]> {
        return this.http.get<Card[]>(`${environment.apiUrl}/${environment.apiVersion}/${this.prefix}/popular/${type}?count=${count}`);
    }

    public getTopEdhrec(count: number): Observable<Card[]> {
        return this.http.get<Card[]>(`${environment.apiUrl}/${environment.apiVersion}/${this.prefix}/top-edhrec?count=${count}`);
    }
}


